export default [
  require("./playerProfiles/players/lucy-parker"),
  require("./playerProfiles/players/jorja-fox"),
  require("./playerProfiles/players/emilia-pelgander"),
  require("./playerProfiles/players/asmita-ale"),
  require("./playerProfiles/players/tara-o’hanlon"),
  require("./playerProfiles/players/aileen-whelan"),
  require("./playerProfiles/players/ellie-brazil"),
  require("./playerProfiles/players/catarina-macario"),
  require("./playerProfiles/players/gracie-pearse"),
  require("./playerProfiles/players/martha-thomas"),
  require("./playerProfiles/players/jess-simpson"),
  require("./playerProfiles/players/lauren-james"),
  require("./playerProfiles/players/adriana-leon"),
  require("./playerProfiles/players/hannah-cain"),
  require("./playerProfiles/players/grace-clinton"),
  require("./playerProfiles/players/keira-flannery"),
  require("./playerProfiles/players/sophie-ingle"),
  require("./playerProfiles/players/nikita-parris"),
  require("./playerProfiles/players/kathrine-møller-kühl"),
  require("./playerProfiles/players/victoria-pelova"),
  require("./playerProfiles/players/princess-ademiluyi"),
  require("./playerProfiles/players/zecira-musovic"),
  require("./playerProfiles/players/poppy-pritchard"),
  require("./playerProfiles/players/rachael-laws"),
  require("./playerProfiles/players/lotte-wubben-moy"),
  require("./playerProfiles/players/rachel-corsie"),
  require("./playerProfiles/players/teyah-goldie"),
  require("./playerProfiles/players/millie-turner"),
  require("./playerProfiles/players/johanna-rytting-kaneryd"),
  require("./playerProfiles/players/filippa-angeldal"),
  require("./playerProfiles/players/aimee-palmer"),
  require("./playerProfiles/players/hanna-bennison"),
  require("./playerProfiles/players/lucy-staniforth"),
  require("./playerProfiles/players/missy-bo-kearns"),
  require("./playerProfiles/players/melina-loeck"),
  require("./playerProfiles/players/barbara-votíková"),
  require("./playerProfiles/players/emma-kullberg"),
  require("./playerProfiles/players/madison-haley"),
  require("./playerProfiles/players/mia-fishel"),
  require("./playerProfiles/players/hannah-hampton"),
  require("./playerProfiles/players/yana-daniels"),
  require("./playerProfiles/players/ffion-morgan"),
  require("./playerProfiles/players/kirsty-hanson"),
  require("./playerProfiles/players/mary-fowler"),
  require("./playerProfiles/players/josie-green"),
  require("./playerProfiles/players/taylor-hinds"),
  require("./playerProfiles/players/katie-o'hanlon"),
  require("./playerProfiles/players/sophie-baggaley"),
  require("./playerProfiles/players/erin-cuthbert"),
  require("./playerProfiles/players/jessie-stapleton"),
  require("./playerProfiles/players/frida-maanum"),
  require("./playerProfiles/players/sille-struck"),
  require("./playerProfiles/players/julie-blakstad"),
  require("./playerProfiles/players/sara-holmgaard"),
  require("./playerProfiles/players/angharad-james"),
  require("./playerProfiles/players/lee-geum-min"),
  require("./playerProfiles/players/olivia-mcloughlin"),
  require("./playerProfiles/players/jess-ziu"),
  require("./playerProfiles/players/soraya-walsh"),
  require("./playerProfiles/players/gemma-bonner"),
  require("./playerProfiles/players/brooke-aspin"),
  require("./playerProfiles/players/jennifer-beattie"),
  require("./playerProfiles/players/ria-percival"),
  require("./playerProfiles/players/lize-kop"),
  require("./playerProfiles/players/hayley-ladd"),
  require("./playerProfiles/players/vivianne-miedema"),
  require("./playerProfiles/players/ashley-lawrence"),
  require("./playerProfiles/players/anna-patten"),
  require("./playerProfiles/players/ava-baker"),
  require("./playerProfiles/players/emma-harries"),
  require("./playerProfiles/players/sarah-bouhaddi"),
  require("./playerProfiles/players/player-not-available"),
  require("./playerProfiles/players/lia-walti"),
  require("./playerProfiles/players/jesse-woolley"),
  require("./playerProfiles/players/sarah-mayling"),
  require("./playerProfiles/players/chloe-mustaki"),
  require("./playerProfiles/players/evie-rabjohn"),
  require("./playerProfiles/players/amanda-ilestedt"),
  require("./playerProfiles/players/stina-blackstenius"),
  require("./playerProfiles/players/jordan-nobbs"),
  require("./playerProfiles/players/chloe-kelly"),
  require("./playerProfiles/players/melanie-leupolz"),
  require("./playerProfiles/players/vicky-losada"),
  require("./playerProfiles/players/tatiana-pinto"),
  require("./playerProfiles/players/annie-hutchings"),
  require("./playerProfiles/players/sabrina-d'angelo"),
  require("./playerProfiles/players/demi-stokes"),
  require("./playerProfiles/players/katie-robinson"),
  require("./playerProfiles/players/megan-shaw"),
  require("./playerProfiles/players/eleanor-dale"),
  require("./playerProfiles/players/lisa-evans"),
  require("./playerProfiles/players/laura-coombs"),
  require("./playerProfiles/players/katrine-veje"),
  require("./playerProfiles/players/jamie-lee-napier"),
  require("./playerProfiles/players/hawa-cissoko"),
  require("./playerProfiles/players/jessie-fleming"),
  require("./playerProfiles/players/shannon-o'brien"),
  require("./playerProfiles/players/naomi-layzell"),
  require("./playerProfiles/players/monique-robinson"),
  require("./playerProfiles/players/elise-stenevik"),
  require("./playerProfiles/players/taylor-smith"),
  require("./playerProfiles/players/katja-snoeijs"),
  require("./playerProfiles/players/katrina-gorry"),
  require("./playerProfiles/players/rachel-furness"),
  require("./playerProfiles/players/gabrielle-george"),
  require("./playerProfiles/players/marie-höbinger"),
  require("./playerProfiles/players/alanna-kennedy"),
  require("./playerProfiles/players/charlize-rule"),
  require("./playerProfiles/players/gio-queiroz"),
  require("./playerProfiles/players/laia-codina"),
  require("./playerProfiles/players/kirsty-smith"),
  require("./playerProfiles/players/danielle-turner"),
  require("./playerProfiles/players/drew-spence"),
  require("./playerProfiles/players/mackenzie-arnold"),
  require("./playerProfiles/players/rikke-madsen"),
  require("./playerProfiles/players/emily-ramsey"),
  require("./playerProfiles/players/fuka-nagano"),
  require("./playerProfiles/players/saori-takarada"),
  require("./playerProfiles/players/charli-grant"),
  require("./playerProfiles/players/player-not-available"),
  require("./playerProfiles/players/anouk-denton"),
  require("./playerProfiles/players/courtney-brosnan"),
  require("./playerProfiles/players/cj-bott"),
  require("./playerProfiles/players/jasmine-bull"),
  require("./playerProfiles/players/leanne-kiernan"),
  require("./playerProfiles/players/emma-koivisto"),
  require("./playerProfiles/players/kit-graham"),
  require("./playerProfiles/players/justine-vanhaevermaet"),
  require("./playerProfiles/players/poppy-pattinson"),
  require("./playerProfiles/players/amber-tysiak"),
  require("./playerProfiles/players/eveliina-summanen"),
  require("./playerProfiles/players/dagný-brynjarsdóttir"),
  require("./playerProfiles/players/kristie-mewis"),
  require("./playerProfiles/players/leila-ouahabi"),
  require("./playerProfiles/players/demi-lambourne"),
  require("./playerProfiles/players/alessia-russo"),
  require("./playerProfiles/players/aoife-mannion"),
  require("./playerProfiles/players/sophie-haug"),
  require("./playerProfiles/players/jill-roord"),
  require("./playerProfiles/players/noelle-maritz"),
  require("./playerProfiles/players/aurora-galli"),
  require("./playerProfiles/players/emily-fox"),
  require("./playerProfiles/players/tianna-teisar"),
  require("./playerProfiles/players/teagan-micah"),
  require("./playerProfiles/players/rachel-daly"),
  require("./playerProfiles/players/courtney-nevin"),
  require("./playerProfiles/players/ashleigh-neville"),
  require("./playerProfiles/players/dejana-stefanović"),
  require("./playerProfiles/players/grace-fisk"),
  require("./playerProfiles/players/melissa-lawley"),
  require("./playerProfiles/players/remy-siemsen"),
  require("./playerProfiles/players/maisie-symonds"),
  require("./playerProfiles/players/jelena-čanković"),
  require("./playerProfiles/players/jenna-clark"),
  require("./playerProfiles/players/megan-walsh"),
  require("./playerProfiles/players/melvine-malard"),
  require("./playerProfiles/players/alex-greenwood"),
  require("./playerProfiles/players/shelina-zadorsky"),
  require("./playerProfiles/players/jayde-riviere"),
  require("./playerProfiles/players/megan-campbell"),
  require("./playerProfiles/players/erin-foley"),
  require("./playerProfiles/players/elisabeth-terland"),
  require("./playerProfiles/players/sofie-lundgaard"),
  require("./playerProfiles/players/wang-shuang"),
  require("./playerProfiles/players/martina-piemonte"),
  require("./playerProfiles/players/amy-turner"),
  require("./playerProfiles/players/molly-bartrip"),
  require("./playerProfiles/players/julia-zigiotti"),
  require("./playerProfiles/players/ebony-salmon"),
  require("./playerProfiles/players/amy-rodgers"),
  require("./playerProfiles/players/satara-murray"),
  require("./playerProfiles/players/ann-katrin-berger"),
  require("./playerProfiles/players/melisa-filis"),
  require("./playerProfiles/players/leah-galton"),
  require("./playerProfiles/players/missy-goodwin"),
  require("./playerProfiles/players/emma-snerle"),
  require("./playerProfiles/players/amalie-thestrup"),
  require("./playerProfiles/players/honoka-hayashi"),
  require("./playerProfiles/players/luana-bühler"),
  require("./playerProfiles/players/manuela-zinsberger"),
  require("./playerProfiles/players/caitlin-foord"),
  require("./playerProfiles/players/carrie-jones"),
  require("./playerProfiles/players/steph-houghton"),
  require("./playerProfiles/players/niamh-fahey"),
  require("./playerProfiles/players/celin-bizet-iidusoy"),
  require("./playerProfiles/players/khadija-shaw"),
  require("./playerProfiles/players/nicky-evrard"),
  require("./playerProfiles/players/sandy-maciver"),
  require("./playerProfiles/players/kaylan-marckese"),
  require("./playerProfiles/players/shanice-van-de-sanden"),
  require("./playerProfiles/players/leah-williamson"),
  require("./playerProfiles/players/mayra-ramirez"),
  require("./playerProfiles/players/jorelyn-carabali"),
  require("./playerProfiles/players/nathalie-bjorn"),
  require("./playerProfiles/players/laia-aleixandri"),
  require("./playerProfiles/players/sjoeke-nüsken"),
  require("./playerProfiles/players/abi-harrison"),
  require("./playerProfiles/players/maz-pacheco"),
  require("./playerProfiles/players/geyse-da-silva"),
  require("./playerProfiles/players/deyna-castellanos"),
  require("./playerProfiles/players/janice-cayman"),
  require("./playerProfiles/players/abby-clarke"),
  require("./playerProfiles/players/niamh-charles"),
  require("./playerProfiles/players/jess-park"),
  require("./playerProfiles/players/michelle-agyemang"),
  require("./playerProfiles/players/anna-leat"),
  require("./playerProfiles/players/bethany-england"),
  require("./playerProfiles/players/pauline-bremer"),
  require("./playerProfiles/players/freya-gregory"),
  require("./playerProfiles/players/megan-connolly"),
  require("./playerProfiles/players/matilda-vinberg"),
  require("./playerProfiles/players/khiara-keating"),
  require("./playerProfiles/players/cloe-lacasse"),
  require("./playerProfiles/players/madison-earl"),
  require("./playerProfiles/players/jutta-rantala"),
  require("./playerProfiles/players/laura-wienroither"),
  require("./playerProfiles/players/kyra-cooney-cross"),
  require("./playerProfiles/players/jessica-naz"),
  require("./playerProfiles/players/ceri-holland"),
  require("./playerProfiles/players/mari-ward"),
  require("./playerProfiles/players/becky-spencer"),
  require("./playerProfiles/players/jess-carter"),
  require("./playerProfiles/players/katie-zelem"),
  require("./playerProfiles/players/shannon-cooke"),
  require("./playerProfiles/players/veatriki-sarri"),
  require("./playerProfiles/players/abbey-leigh-stringer"),
  require("./playerProfiles/players/karoline-olesen"),
  require("./playerProfiles/players/benedicte-håland"),
  require("./playerProfiles/players/rachel-williams"),
  require("./playerProfiles/players/alice-keitley"),
  require("./playerProfiles/players/fran-kirby"),
  require("./playerProfiles/players/sophie-howard"),
  require("./playerProfiles/players/katie-startup"),
  require("./playerProfiles/players/miri-taylor"),
  require("./playerProfiles/players/laura-blindkilde"),
  require("./playerProfiles/players/marika-bergman-lundin"),
  require("./playerProfiles/players/millie-bright"),
  require("./playerProfiles/players/steph-catley"),
  require("./playerProfiles/players/yui-hasegawa"),
  require("./playerProfiles/players/emma-bissell"),
  require("./playerProfiles/players/riko-ueki"),
  require("./playerProfiles/players/kim-little"),
  require("./playerProfiles/players/natasha-flint"),
  require("./playerProfiles/players/kayleigh-green"),
  require("./playerProfiles/players/katerina-svitkova"),
  require("./playerProfiles/players/ellie-roebuck"),
  require("./playerProfiles/players/sophia-poor"),
  require("./playerProfiles/players/izzy-atkinson"),
  require("./playerProfiles/players/lucy-parry"),
  require("./playerProfiles/players/lena-petermann"),
  require("./playerProfiles/players/eve-perisset"),
  require("./playerProfiles/players/megan-finnigan"),
  require("./playerProfiles/players/ella-toone"),
  require("./playerProfiles/players/janina-leitzig"),
  require("./playerProfiles/players/deanne-rose"),
  require("./playerProfiles/players/emma-watson"),
  require("./playerProfiles/players/denny-draper"),
  require("./playerProfiles/players/sam-kerr"),
  require("./playerProfiles/players/shania-hayles"),
  require("./playerProfiles/players/zhang-linyan"),
  require("./playerProfiles/players/gemma-evans"),
  require("./playerProfiles/players/toni-duggan"),
  require("./playerProfiles/players/guro-reiten"),
  require("./playerProfiles/players/agnes-beever-jones"),
  require("./playerProfiles/players/sarah-stratigakis"),
  require("./playerProfiles/players/shae-yanez"),
  require("./playerProfiles/players/irene-guerrero"),
  require("./playerProfiles/players/mia-enderby"),
  require("./playerProfiles/players/beth-mead"),
  require("./playerProfiles/players/aniek-nouwen"),
  require("./playerProfiles/players/katie-mccabe"),
  require("./playerProfiles/players/ella-powell"),
  require("./playerProfiles/players/heather-payne"),
  require("./playerProfiles/players/emily-syme"),
  require("./playerProfiles/players/phallon-tullis-joyce"),
  require("./playerProfiles/players/maya-le-tissier"),
  require("./playerProfiles/players/kerstin-casparij"),
  require("./playerProfiles/players/kenza-dali"),
  require("./playerProfiles/players/karen-holmgaard"),
  require("./playerProfiles/players/simone-magill"),
  require("./playerProfiles/players/viviane-asseyi"),
  require("./playerProfiles/players/amanda-nildén"),
  require("./playerProfiles/players/kadeisha-buchanan"),
  require("./playerProfiles/players/ruby-mace"),
  require("./playerProfiles/players/jasmine-matthews"),
  require("./playerProfiles/players/eleanor-heeps"),
  require("./playerProfiles/players/lucía-garcía"),
  require("./playerProfiles/players/alisha-lehmann"),
  require("./playerProfiles/players/rosella-ayane"),
  require("./playerProfiles/players/julie-thibaud"),
  require("./playerProfiles/players/daphne-van-domselaar"),
  require("./playerProfiles/players/maren-mjelde"),
  require("./playerProfiles/players/maria-thorisdottir"),
  require("./playerProfiles/players/guro-bergsvand"),
  require("./playerProfiles/players/hinata-miyazawa"),
  require("./playerProfiles/players/clare-wheeler"),
  require("./playerProfiles/players/sam-tierney"),
  require("./playerProfiles/players/hannah-blundell"),
  require("./playerProfiles/players/risa-shimizu"),
  require("./playerProfiles/players/maddi-wilde"),
  require("./playerProfiles/players/olivia-clark"),
  require("./playerProfiles/players/fran-bentley"),
  require("./playerProfiles/players/ramona-petzelberger"),
  require("./playerProfiles/players/yuka-momiki"),
  require("./playerProfiles/players/lauren-hemp"),
  require("./playerProfiles/players/mary-earps"),
  require("./playerProfiles/players/lina-hurtig"),
  require("./playerProfiles/players/lisa-naalsund"),
  require("./playerProfiles/players/olga-ahtinen"),
  require("./playerProfiles/players/esme-morgan"),
  require("./playerProfiles/players/lucy-hope"),
]